import { configuration } from '@environment-config/configuration.prod';
import { IEnvironment } from './env.model';

export const environment: IEnvironment = {
	...configuration.remotes,
	production: true,
	installerURL: configuration.installerURL,
	azureBucketURL: configuration.azureBucketURL,
	apiUrl: configuration.apiUrl,
	featureFlag: {
		LAUNCHDARKLY_SDK_KEY: configuration.featureFlagEnvKey.launchDarklyKey,
	},
	hotJar: '3552541',
	mixpanel: configuration.mixpanel,
	coralogixPublicKey: configuration.coralogixPublicKey,
};
